import { ReactNode } from "react";
import { RouterConfiguration } from "./types";
import { RoutingProvider } from "./RoutingProvider";
import { ReactRouterProvider } from "./ReactRouterProvider";

export const RoutingOverrideProvider = ({
  children,
  override,
}: {
  children: ReactNode;
  override?: RouterConfiguration;
}) => {
  return override !== undefined ? (
    <RoutingProvider {...override}>{children}</RoutingProvider>
  ) : (
    <ReactRouterProvider>{children}</ReactRouterProvider>
  );
};
